<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
      }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Delivery Case</h3>
      <div class="action_bar mb-3">
        <b-button
          v-if="checkPermission($store.state.user_obj, 'Customer Service', 'Delivery Case', 'Create Delivery Case', true)"
          class="btn-action-lg" size="sm" variant="info" :to="{ name: 'change_request_add' }">Create Delivery
          Case</b-button>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select size="sm" v-model="search_criteria.status_selected" :options="status_options" />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="Tracking#"
              v-model="search_criteria.tracking_number" @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.start_at"></b-form-input>
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.end_at"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button v-if="checkPermission($store.state.user_obj, 'Customer Service', 'Delivery Case', 'Search', true)"
              class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button
              v-if="checkPermission($store.state.user_obj, 'Customer Service', 'Delivery Case', 'Export CSV', true)"
              class="btn-action" size="sm" variant="info" @click="exportCSV">Export</b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-table responsive small outlined striped hover :items="items" :fields="fields">
        <template v-slot:cell(status)="data">
          {{ data.item.status }}
        </template>

        <template v-slot:cell(tracking_scheduled_delivery_date)="data">
          {{ displayDate(data.item.tracking_scheduled_delivery_date) }}
        </template>

        <template v-slot:cell(field_name)="data">
          <span v-if="data.item.field_name != 'courier_short_name'">
            {{ data.item.field_name }}
          </span>

          <span v-if="data.item.field_name == 'courier_short_name'">
            courier
          </span>
        </template>

        <template v-slot:cell(changes)="data">
          <div style="max-width: 250px; white-space: pre-line; word-break: break-word;">
            {{ (data.item.to_val == 'null') ? '-' : data.item.to_val }}
            <div v-if="data.item.other_reason"></div>
          </div>
        </template>

        <template v-slot:cell(remark)="data">
          <b-button v-if="data.item.remark && data.item.remark != ''" type="button" size="sm" variant="primary"
            @click="onToggleRemark(data.item)">
            <span v-if="!data.item.isShowRemark">Show</span>
            <span v-if="data.item.isShowRemark">Hide</span>
          </b-button>
          <div v-show="data.item.isShowRemark">
            {{ data.item.remark }}
          </div>
        </template>

        <template v-slot:cell(updated_at)="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button class="btn-action" size="sm" variant="info" :to="{
            name: 'tracking_detail',
            params: { id: data.item.tracking_id }
          }" :disabled="!data.item.tracking_id">Detail</b-button>

          <b-button v-if="
            checkPermission(
              $store.state.user_obj,
              'Customer Service',
              'Delivery Case',
              'Execute',
              (
                ($store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'cs' ||
                  $store.state.user_obj.account_type == 'client_admin') &&
                data.item.status == 'pending'
              )
            )
          " class="btn-action" size="sm" variant="success" @click.stop="executeCR(data.item)">Execute</b-button>

          <b-button v-if="(data.item.status == 'pending')" class="btn-action" size="sm" variant="danger"
            @click.stop="cancelCR(data.item)">Cancel</b-button>
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="TABLE_LIMIT"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_number",
    label: "Order#"
  },
  {
    key: "tracking_scheduled_delivery_date",
    label: "Scheduled Delivery Date"
  },
  {
    key: "remark",
    label: "Remark"
  },
  {
    key: "field_name",
    label: "Field Name"
  },
  {
    key: "changes",
    label: "Changes"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "created_by",
    label: "Requested By"
  },
  {
    key: "created_at",
    label: "Submitted at"
  },
  {
    key: "updated_by",
    label: "Executed By"
  },
  {
    key: "updated_at",
    label: "Executed at"
  },
  {
    key: "action",
    label: "Action"
  }
];

import global_function from "../mixins/global_function";

export default {
  name: "ChangeRequests",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [global_function],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: false,
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_tracking_number: "",
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: "pending",
        start_at: null,
        end_at: null,
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "pending",
          text: "pending"
        },
        {
          value: "cancel",
          text: "cancel"
        },
        {
          value: "executed",
          text: "executed"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: ""
    };
  },
  async created() {
    await this.getChangeRequests();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST;
      export_url += "/change_request_export.php?";
      export_url += "&tracking_number=" + this.search_criteria.tracking_number;
      export_url += "&status_selected=" + this.search_criteria.status_selected;
      export_url += "&start_at=" + this.search_criteria.start_at;
      export_url += "&end_at=" + this.search_criteria.end_at;
      export_url += "&client_id=" + this.$store.state.user_obj.client_id;
      export_url = encodeURI(export_url);

      console.log(export_url);

      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getChangeRequests() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          account_type: 'raze',
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      for (let i in response.data.change_requests) {
        response.data.change_requests[i].isShowRemark = false;
      }
      this.items = response.data.change_requests;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getChangeRequests();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getChangeRequests();
    },

    async executeCR(cr_item) {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_execute.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      if (response.data.status == "success") {
        this.getChangeRequests();
      } else {
        alert(response.data.error_msg);
      }

      this.loader.hide();
    },

    async cancelCR(cr_item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_cancel.php",
        data: {
          change_request_id: cr_item.id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.getChangeRequests();
    },

    async updateChangeRequest(change_request_id, status) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "change_request_update.php",
        data: {
          change_request_id: change_request_id,
          status: status,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Delivery Case #${tracking_obj.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getChangeRequests();
      } else {
        this.alert_error_message = `Delivery Case #${tracking_obj.id} Not Found.`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
      }

      this.$refs.modal_reschedule_tracking.hide();
      this.$refs.modal_cancelTracking.hide();
    },

    onToggleRemark(item) {
      item.isShowRemark = !item.isShowRemark;
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/ChangeRequests.vue